@if (openOrders?.length == 0) {
  <p class="orange">Aftalen har ingen ordre med deadline efter valgte slutdato</p>
}

@if (openOrders?.length > 0) {
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
    <ng-container matColumnDef="markAction">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let serviceordre">
        <mat-checkbox
          [checked]="ordersToBeCanceled.has(serviceordre.serviceordreNo)"
          [disabled]="isOrderAfterDeadline(serviceordre)"
          (change)="onServicOrderCheckChange($event.checked, serviceordre)"
        ></mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="ordrenr">
      <th mat-header-cell *matHeaderCellDef>Ordrenr.</th>
      <td mat-cell *matCellDef="let serviceordre">{{ serviceordre.serviceordreNo }}</td>
    </ng-container>
    <ng-container matColumnDef="opgave">
      <th mat-header-cell *matHeaderCellDef>Opgave</th>
      <td mat-cell *matCellDef="let serviceordre">{{ serviceordre.opgaveDisplayText }}</td>
    </ng-container>
    <ng-container matColumnDef="deadline">
      <th mat-header-cell *matHeaderCellDef>Deadline</th>
      <td mat-cell *matCellDef="let serviceordre">{{ serviceordre.deadline | date : 'dd.MM.yyyy' }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">{{ serviceordre.serviceordreStateUserText }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="beskrivelse">
      <th mat-header-cell *matHeaderCellDef>Beskrivelse</th>
      <td mat-cell *matCellDef="let serviceordre">{{ serviceordre.description }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="activeColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: activeColumns"></tr>
  </table>
  <form [formGroup]="form">
    <div class="form-row">
      <mat-form-field appearance="outline" class="mdc-textarea-fix">
        <mat-label>Angiv årsag til annullering</mat-label>
        <textarea formControlName="terminationCauseForServiceordre" rows="3" maxlength="250" matInput></textarea>
        <mat-hint align="end">
          <app-character-count [control]="terminationCauseForServiceordre" [maxlength]="250"></app-character-count>
        </mat-hint>
      </mat-form-field>
    </div>
  </form>
}
